import Alpine from "alpinejs";

const data = (params = {}) => ({
  /**
   *  Data
   */
  minusColumn: 0,
  /**
   *  Targets
   */

  targets: {
    leftBtn: {
      ["x-on:click"]: "leftBtn($event)",
    },
    deletedBtn: {
      ["x-on:click"]: "deletedBtn($event)",
    },
  },
  /**
   *  Main & Event Callback
   */

  init() {
    this.resetArrowBtn();
  },
  get tableRow() {
    return this.$root.rows;
  },
  selectedIdx(e) {
    const tds = e.target.closest("tr").querySelectorAll("td");
    const idx = [...tds].indexOf(e.target.closest("td")) + 1;
    return idx;
  },
  leftBtn(e) {
    const idx = this.selectedIdx(e);
    for (let i = 0; i < this.$root.rows.length; i++) {
      const selectedCell = this.$root.rows[i].cells[idx];
      const moveToCell = this.$root.rows[i].cells[idx].previousElementSibling;
      this.$root.rows[i].insertBefore(selectedCell, moveToCell);
    }
    this.resetArrowBtn();
  },
  deletedBtn(id) {
    const url = new URL(window.location.href);
    const search = new URLSearchParams(url.search);
    let fund_ids = search.get('fund_ids');
    fund_ids = fund_ids.split(',').filter(id_fund => id_fund != id).join(',');
    search.set('fund_ids', fund_ids);
    url.search = search.toString().replace(/%2C/g, ',');
    window.location.href = url.toString();
  },
  resetArrowBtn() {
    const lastRowIndex = this.$root.rows.length - 1;
    const tdList = this.$root.rows[lastRowIndex].querySelectorAll("td");

    for (let i = 0; i < tdList.length; i++) {
      let leftBtn = tdList[i].querySelector(`[x-ref='leftBtn']`);
      const disableClasses = '!text-slate-300 !border-slate-300 !bg-slate-50 pointer-events-none'
          .split(' ')
          .filter(className => className.length > 0);

      leftBtn.classList.add(...disableClasses);
      leftBtn.setAttribute('aria-disabled', 'true');
      if (i !== 0) {
        leftBtn.classList.remove(...disableClasses);
        leftBtn.removeAttribute('aria-disabled');
      }
    }
  },
  ...params,
});

Alpine.data("tableColumnMove", data);
export default data;
